import { Box, Button, Modal, TablePagination, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { useLoginStore } from "../../store/zustand";
import apiMo from "../../axios/axios";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import Swal from "sweetalert2";



interface ICodigo {
    id_codigo: number,
    codigo: string,
    descripcion: string,
    activo: number,
    precio: number
}


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '75%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const CrudCodigos = () => {


    const { loginStore } = useLoginStore()

    const [catCodigo, setCatCodigo] = useState([]);
    const [infoCodigo, setInfoCodigo] = useState<ICodigo>();
    const [openModal, setOpenModal] = useState(false);
    const [openModalAlta, setOpenModalAlta] = useState(false);
    const [infoEditCodigo, setInfoEditCodigo] = useState<ICodigo>();
    const [idEditCodigo, setIdEditCodigo] = useState(null)
    const [altaCodigo, setAltaCodigo] = useState({ codigo: '', precio: -1, descripcion: '' })

    const [codigoEdit, setCodigoEdit] = useState('')
    const [descrEdit, setDescrEdit] = useState('')
    const [precioEdit, setPrecioEdit] = useState(0)

    const [page, setPage] = useState(0); // página actual
    const [rowsPerPage, setRowsPerPage] = useState(10); // registros por página


    const buscarCodigos = () => {


        const buscandoCodigos = async () => {

            try {

                const cargarCodigos = await apiMo.get('/leer-catalogo-codigos', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setCatCodigo(cargarCodigos.data)

            } catch (error: any) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al cargar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }


        }

        buscandoCodigos()
    }

    useEffect(() => {

        buscarCodigos()

    }, [])

    const buscarCodigo = (id_codigo: number) => {

        const buscandoCodigo = async () => {

            try {

                const cargarCodigos = await apiMo.get(`/buscar-info-codigo/${id_codigo}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setInfoCodigo(cargarCodigos.data)
                setCodigoEdit(cargarCodigos.data.codigo)
                setDescrEdit(cargarCodigos.data.descripcion)
                setPrecioEdit(cargarCodigos.data.precio)
                setIdEditCodigo(cargarCodigos.data.id_codigo)

                setOpenModal(true)

            } catch (error: any) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al cargar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        buscandoCodigo()

    }

    const infoEdicionCodigo = (e: any) => {

        const { name, value } = e.target

        switch (name) {
            case 'Codigo':
                setCodigoEdit(value.toUpperCase())
                break;
            case 'Descripcion':
                setDescrEdit(value.toUpperCase())
                break;
            case 'Precio':
                setPrecioEdit(value.toUpperCase())
                break;

        }




    }

    const modificarCodigo = () => {

        if (!idEditCodigo) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Es necesario seleccionar codigo!'
            })
            return
        }

        const modifCodigo = async () => {
            let closedManually = false;
            try {

                const jModifCodigo = {
                    codigo: codigoEdit,
                    descripcion: descrEdit,
                    precio: precioEdit
                }

                const modificando = await apiMo.post(`/modificar-codigo/${idEditCodigo}`, jModifCodigo, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setOpenModal(false)
                buscarCodigos()
                toast.success(modificando.data.mensaje, toast_config);



            } catch (error: any) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al cargar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }


        }

        modifCodigo()

    }

    const cambiarEstatusActivo = (idc: number) => {

        Swal.fire({
            title: "Estas seguro?",
            text: "Se dara de baja codigo!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, Cambiar!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    const cambiarStatus = await apiMo.put(`/cambiar-estatus-codigo/${idc}`, null, {
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`,
                            'Accept': 'application/x-www-form-urlencoded',
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    })

                    buscarCodigos()
                    toast.success(cambiarStatus.data.mensaje, toast_config);

                } catch (error: any) {
                    let msg_error = ''
                    if (error.response) {
                        if (error.response.data.error) {
                            msg_error = error.response.data.error
                        } else {
                            msg_error = 'Ocurrió un error al cambiar status!'
                        }
                    }
                    //mensaje de toastify
                    toast.error(msg_error, toast_config)
                }
            }
        });


    }


    const leerDatosAltaCodigo = (e: any) => {

        setAltaCodigo({
            ...altaCodigo,
            [e.target.name]: e.target.value
        })
    }



    const agregarCodigo = () => {

        const addCodigo = async () => {

            try {

                if (!altaCodigo.codigo) return toast.error('Es obligatorio el codigo!', toast_config)
                if (altaCodigo.precio < 0) return toast.error('Es obligatorio el codigo!', toast_config)
                if (!altaCodigo.descripcion) return toast.error('Es obligatorio el codigo!', toast_config)

                const agregando = await apiMo.post('/agregar-articulo', altaCodigo, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                buscarCodigos()
                setOpenModalAlta(false)

                toast.success(agregando.data.mensaje, toast_config)



            } catch (error: any) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al agregar codigo!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }


        }

        addCodigo()

    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // regresar a la primera página
    };

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card shadow">
                            <div className="card-body">
                                <Button variant="contained" className="mb-5" onClick={() => setOpenModalAlta(true)}>Agregar Codigo</Button>

                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 700 }} aria-label="customized table" className="animation-layout">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Codigo</StyledTableCell>
                                                <StyledTableCell align="center">Descripcion</StyledTableCell>
                                                <StyledTableCell align="center">Precio</StyledTableCell>
                                                <StyledTableCell align="center">Activo</StyledTableCell>
                                                <StyledTableCell align="center">Editar</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {catCodigo && catCodigo
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((codigo: { id_codigo: number; codigo: string; descripcion: string; precio: string; activo: number; }) => (
                                                <StyledTableRow key={codigo.id_codigo.toString()}>
                                                    <StyledTableCell component="th" scope="row">
                                                        {codigo.codigo}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">{codigo.descripcion}</StyledTableCell>
                                                    <StyledTableCell align="center">${codigo.precio}</StyledTableCell>
                                                    <StyledTableCell onClick={() => cambiarEstatusActivo(codigo.id_codigo)} align="center" className={codigo.activo == 1 ? 'text-success pointer' : 'text-danger pointer'}>
                                                        {codigo.activo == 1 ? 'ACTIVO' : 'INACTIVO'}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center" >
                                                        <EditIcon style={{ 'cursor': 'pointer' }} onClick={() => buscarCodigo(codigo.id_codigo)} />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={catCodigo.length}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                                        labelRowsPerPage="Registros por página"
                                    />
                                </TableContainer>

                            </div>
                            <Modal
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={style}>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6 d-flex justify-content-center mb-3">
                                                    <TextField variant="standard" style={{ 'width': '75%' }} label="Codigo" name="Codigo" value={codigoEdit} onChange={infoEdicionCodigo} />
                                                </div>

                                                <div className="col-md-6 d-flex justify-content-center mb-3">
                                                    <TextField type="number" variant="standard" style={{ 'width': '75%' }} label="Precio" name="Precio" value={precioEdit} onChange={infoEdicionCodigo} />
                                                </div>

                                                <div className="col-md-12 d-flex justify-content-center mb-3">
                                                    <TextField variant="standard" style={{ 'width': '75%' }} label="Descripcion" name="Descripcion" value={descrEdit} onChange={infoEdicionCodigo} />
                                                </div>

                                                <div className="col-md-12 d-flex justify-content-center mt-3">
                                                    <Button variant="outlined" onClick={modificarCodigo}>Modificar</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </Box>
                            </Modal>

                            <Modal
                                open={openModalAlta}
                                onClose={() => setOpenModalAlta(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={style}>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6 d-flex justify-content-center mb-3">
                                                    <TextField variant="standard" style={{ 'width': '75%' }} label="Codigo" name="codigo" onChange={leerDatosAltaCodigo} />
                                                </div>

                                                <div className="col-md-6 d-flex justify-content-center mb-3">
                                                    <TextField type="number" variant="standard" style={{ 'width': '75%' }} label="Precio" name="precio" onChange={leerDatosAltaCodigo} />
                                                </div>

                                                <div className="col-md-12 d-flex justify-content-center mb-3">
                                                    <TextField variant="standard" style={{ 'width': '75%' }} label="Descripcion" name="descripcion" onChange={leerDatosAltaCodigo} />
                                                </div>

                                                <div className="col-md-12 d-flex justify-content-center mt-3">
                                                    <Button variant="outlined" onClick={agregarCodigo}>Agregar</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </Box>
                            </Modal>



                            <hr />
                        </div>

                    </div>
                </div>

                <ToastContainer position="bottom-center"
                    transition={Flip}
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
            </div>

        </>
    )

}


export default CrudCodigos